import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { bytesToString } from "@/utils/utils";
import {} from "./model";
import QuotaUsageBar from "./QuotaUsageBar.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuotaUsageSummary',
    props: {
        quotaUsages: null
    },
    setup(__props, { expose }) {
        const props = __props;
        const totalQuotaInBytes = computed(() => {
            const totalQuota = props.quotaUsages.reduce((acc, item) => acc + (item.quotaInBytes ?? 0), 0);
            return totalQuota;
        });
        const niceTotalQuota = computed(() => {
            return bytesToString(totalQuotaInBytes.value, true, undefined);
        });
        const allSourcesUnlimited = computed(() => {
            const allUnlimited = props.quotaUsages.every((usage) => usage.isUnlimited);
            return allUnlimited;
        });
        expose({
            totalQuotaInBytes,
        });
        return { __sfc: true, props, totalQuotaInBytes, niceTotalQuota, allSourcesUnlimited, QuotaUsageBar };
    }
});
